<template>
  <send-form :can-back="true" :double-send="double" @submit.prevent="doSend" @back="toLogin">
    <form-caption v-if="pageTitle" :text="pageTitle" />
    <p>
      パスワードをお忘れの方は、こちらからパスワードを再設定してください。<br>
      登録時のメールアドレスを入力して、送信ボタンを押してください。<br>
      メールにてパスワード変更用のURL、仮パスワードをお送りします。<br>
      仮パスワードでログインし、アカウント情報の編集で新しいパスワードを設定してください。<br>
    </p>
    <vuex-email-form-item class="my-3" label="メールアドレス" bind="email" />
  </send-form>
</template>

<script>
import SendForm from "@/views/templates/forms/SendForm";
import FormCaption from '@/views/atoms/FormCaption'
import VuexEmailFormItem from "@/views/molecules/formItems/VuexEmailFormItem";

export default {
  name: 'ForgotPassword',
  components: {
    SendForm,
    FormCaption,
    VuexEmailFormItem,
  },
  provide: {
    bindModule: 'password_reissue_form'
  },
  data(){
    return {
      double: false,
    }
  },
  computed: {
    pageTitle() {
      return this.$store.state.pageTitle;
    },
  },
  mounted() {
    this.$store.commit('password_reissue_form/resetData');
    this.$store.commit('password_reissue_form/clearError');
  },
  methods: {
    doSend() {
      this.double = true; //二重送信防止のため送信ボタンを一時非アクティブに
      this.$store.dispatch('password_reissue_form/send').then(() => {
        this.$root.showFlashMessage();
        this.double = false;
      }).catch(reason => {
        this.$root.failApi(reason)
        this.double = false;
      });
    },
    toLogin() {
      const managementCompanyCode = localStorage.getItem('managementCompanyCode');
      if (managementCompanyCode){
        this.$router.push({name: 'Login', query: {mccd: managementCompanyCode}});
      } else {
        this.$router.push({name: 'Login'});
      }
    },
  }
}
</script>
